import { render, staticRenderFns } from "./boss-breadcrumb.vue?vue&type=template&id=632b238c&scoped=true"
import script from "./boss-breadcrumb.vue?vue&type=script&lang=js"
export * from "./boss-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./boss-breadcrumb.vue?vue&type=style&index=0&id=632b238c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b238c",
  null
  
)

export default component.exports